import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import queryString from 'query-string';

import SuccessMessage from './success';
import { apiHost } from '../utils/request';

const UserApproval = ({ history }) => {
  const {
    location: { search }
  } = history;
  const parsed = queryString.parse(search);

  useEffect(() => {
    axios
      .post(
        `${apiHost}/${parsed.option === '1' ? 'users/approve' : 'users/reject'}`,
        { code: parsed.code }
      )
      .then(() => {
        // handle response
      })
      .catch(() => {
        // eslint
      })
      .then(() => {
        // finally
      });
  }, []);

  return (
    <>
      <SuccessMessage status={parsed.option} />
    </>
  );
};

UserApproval.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.object.isRequired
  }).isRequired,
};
export default UserApproval;
